import {
  ReferenceField,
  useRecordContext,
} from "react-admin";
import { Button, Stack } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import { joinAddressLine } from "../components/raFormat";
import { ClientMeta } from "./ClientEdit";
import {
  AppShow,
  AppShowActions,
  AppShowCard,
  AppShowContent,
  AppShowSection,
  AppShowSectionHeader,
  AppShowField,
  AppShowTextField,
} from "@/adapters/inbound/layout";

function ClientQuickActions() {
  const r = useRecordContext<any>();
  if (!r) return null;

  return (
    <Stack direction="row" spacing={1} flexWrap="wrap">
      <Button
        size="small"
        variant="outlined"
        startIcon={<PhoneIcon />}
        disabled={!r.phone}
        component="a"
        href={r.phone ? `tel:${r.phone}` : undefined}
      >
        Anrufen
      </Button>

      <Button
        size="small"
        variant="outlined"
        startIcon={<EmailIcon />}
        disabled={!r.email}
        component="a"
        href={r.email ? `mailto:${r.email}` : undefined}
      >
        E-Mail
      </Button>
    </Stack>
  );
}

export const ClientShow = () => (
  <AppShow actions={<AppShowActions />} aside={<ClientMeta />}>
    <AppShowCard>
      <AppShowContent>
        <AppShowSection>
          <AppShowSectionHeader
            title="Kunde"
            subtitle="Stammdaten und Ansprechpartner."
          />
          <AppShowTextField source="name" label="Name" />
          <AppShowTextField
            source="contactName"
            label="Ansprechpartner"
            emptyText="—"
          />
        </AppShowSection>

        <AppShowSection>
          <AppShowSectionHeader
            title="Kontakt"
            subtitle="Direkte Kontaktmöglichkeiten."
          />
          <AppShowField label="Aktionen">
            <ClientQuickActions />
          </AppShowField>
          <AppShowTextField source="phone" label="Telefon" emptyText="—" />
          <AppShowTextField source="email" label="E-Mail" emptyText="—" />
        </AppShowSection>

        <AppShowSection>
          <AppShowSectionHeader
            title="Adresse"
            subtitle="Verknüpfte Kundenadresse."
          />
          <AppShowField label="Adresse">
            <ReferenceField
              source="addressId"
              reference="addresses"
              link="show"
              label={false}
            >
              <AddressLineField />
            </ReferenceField>
          </AppShowField>
        </AppShowSection>
      </AppShowContent>
    </AppShowCard>
  </AppShow>
);

function AddressLineField() {
  const address = useRecordContext<any>();
  if (!address) return null;
  return <>{joinAddressLine(address)}</>;
}
